import { UploadDocumentType } from "../../../types";

import { DocumentUpload } from "./document-upload";

export const BalanceSheetDocumentUploadPanel = ({
  error,
  onUploadSuccess,
}: {
  error?: string;
  onUploadSuccess?: () => void;
}) => {
  return (
    <DocumentUpload
      documentType={UploadDocumentType.BALANCE_SHEET}
      supportedFileExtensions={[".xlsx", ".pdf"]}
      fileSizeLimitMB={10}
      showHelpText={false}
      error={error}
      onUploadSuccess={onUploadSuccess}
      fullScreenDropzone={false}
    />
  );
};
